// John Eldhose 20210525
import React, { Component } from 'react';
import { loadLoginPage, resetLoginPage } from '../lib/LoginPage';
import { postData } from '../lib/api';
import Loading from '../lib/Loading';

class TeaserForum extends Component {

  state = { stat: 'loading' }
  componentDidMount() {
    var page = loadLoginPage();
    if(page === null)
      page = { url: '/forum', opts: [window.location.search] };
    else
      resetLoginPage();
    if(
      typeof page === 'object' && typeof page.opts === 'object' &&
      typeof page.opts[0] === 'string' && page.opts[0] !== ''
    ) {
      postData('forum', { opts: page.opts[0] })
        .then((data) => {
          if(data.url === '')
            this.setState({ stat: 'error' });
          else
            window.location = data.url;
        })
        .catch((err) => { console.log(err); })
    }
  }
  content = () => {
    switch(this.state.stat) {
      case 'error':
        return <div>Unknown error occurred</div>;
      case 'loading':
      default:
        return <Loading minHeight={350} />;
    }
  }

  render() {
    return this.content();
  }
}

export default TeaserForum;



// WEBPACK FOOTER //
// ./src/components/home/Forum.js